<ion-button *ngIf="!jobItem.canApply && !jobItem.isApplied"  color="basic" appDebounceClick [debounceTime]="700"
            (debounceClick)="showTrainingRequired(jobItem)" class="ion-no-margin btn btn-training">
            Training Required </ion-button>